<dgx-org-groups-header
  [groups]="groups"
  [isLoading]="isLoading"
  [orgId]="orgId"
  (updateQueries)="doSearch($event)"
  (filtersChange)="doFilter($event)"
  [filters]="filters"
></dgx-org-groups-header>
<dgx-data-table
  id="org-groups-header-table"
  [canSelect]="canSelectAny"
  [columns]="columns"
  [items]="groups"
  [isLoading]="isLoading"
  [propTrackingKey]="propTrackingKey"
  (updateSort)="changeSort($event)"
  [orderBy]="orderBy"
  [isDescending]="isDescending"
  [pageNum]="pageNum"
  (pageChange)="pageChange($event)"
  (perPageChange)="perPageChange($event)"
  [numResultsPerPage]="numResultsPerPage"
  [totalNumResults]="totalNumResults"
  [perPageOptions]="[
    { value: 10, display: '10' },
    { value: 30, display: '30' },
    { value: 50, display: '50' },
  ]"
  [showPerPage]="true"
></dgx-data-table>

<div class="grid__col-12 tw-h-70 tw-py-0">
  <dgx-data-bulk-actions
    class="full-width m-guts-m-h-1"
    [numItemsForAction]="selectedGroups?.length || 0"
    (bulkActionsCancelled)="selectNone()"
    bulkEditContainer="org-groups-header-table"
    [bulkActionsEnabled]="showBulkActions"
  >
    <dgx-data-bulk-action-button
      actionIcon="trash"
      [displayText]="i18n.Core_Delete"
      (buttonAction)="showBulkDeleteModal()"
      dgatInput="org-groups-aed"
    ></dgx-data-bulk-action-button>
  </dgx-data-bulk-actions>
</div>
<dgx-footer-glasses></dgx-footer-glasses>

<!-- Custom column templates -->
<ng-template #groupName let-item>
  <span [id]="`table-row-label-${item.id}`">
    @if (item.showGroupLink) {
      <a
        class="uhover break color-ebony"
        [href]="item.url"
        target="_blank"
        data-dgat="orgGroups-bf4"
        >{{ item.name }}</a
      >
    }
    @if (!item.showGroupLink) {
      <span>{{ item.name }}</span>
    }
  </span>
</ng-template>

<ng-template #actionLink let-item>
  @if (item.showLeaveButton) {
    <button
      class="link font-medium"
      [title]="getAriaLabel('OrgGroupsCtrl_LeaveGroup', item.name)"
      [attr.aria-label]="getAriaLabel('OrgGroupsCtrl_LeaveGroup', item.name)"
      (click)="leaveGroup(item)"
      data-dgat="orgGroups-21f"
    >
      {{ i18n.OrgGroupsCtrl_Leave }}
    </button>
  }
  @if (item.showJoinButton) {
    <button
      class="link font-medium"
      [title]="getAriaLabel('OrgGroupsCtrl_JoinGroup', item.name)"
      [attr.aria-label]="getAriaLabel('OrgGroupsCtrl_JoinGroup', item.name)"
      (click)="joinGroup(item)"
      data-dgat="orgGroups-82a"
    >
      {{ i18n.Core_Join }}
    </button>
  }
  @if (item.showRequestButton) {
    <button
      class="link font-medium left-text"
      [title]="getAriaLabel('OrgGroupsCtrl_RequestGroupMembership', item.name)"
      [attr.aria-label]="
        getAriaLabel('OrgGroupsCtrl_RequestGroupMembership', item.name)
      "
      (click)="requestMembership(item)"
      data-dgat="orgGroups-7dd"
    >
      {{ isRebacEnabled ? i18n.dgGroupTile_RequestMembership : i18n.Core_Join }}
    </button>
  }
  @if (item.showPendingRequest) {
    <span>{{ i18n.OrgGroupsCtrl_RequestPending }}</span>
  }
  @if (item.showMemberLabel) {
    <span class="color-ebony-a61">{{ i18n.Core_RoleMember }}</span>
  }
  @if (item.showViewOnlyLabel) {
    <span class="color-ebony-a61">{{ i18n.Core_ViewOnly }}</span>
  }
</ng-template>
<ng-template #visibilityTemplate let-item>
  <span>{{ item.privacyDisplayText }}</span>
  @if (item.privacyLevel === 3) {
    <span class="par par--small par--light block">
      {{
        item.membershipType === 'Dynamic'
          ? i18n.OrgGroupsCtrl_Dynamic
          : i18n.OrgGroupsCtrl_Static
      }}
    </span>
  }
</ng-template>
<ng-template #memberCountTemplate let-item>
  <span>{{ getMemberCountDisplay(item) }}</span>
</ng-template>
<ng-template #attributesTemplate let-item>
  <dgx-predicate-list [predicates]="item.predicates"> </dgx-predicate-list>
</ng-template>
